// Vitrine de produtos (B5a). Modo coleção: o Liquid já desenhou os cards; aqui só liga o
// carrossel. Modo veículo: busca os cards do veículo da garagem pela mesma Section Rendering da
// página do veículo (ds-vehicle-results em /collections/all) e troca os esqueletos por eles.
// QUEM decide URL, título e link é o núcleo (vitrineDoVeiculo em ds-veiculo-core.js, testado).
// Sem veículo, fora do catálogo, sem produto ou erro de rede: data-estado="vazia" e a vitrine
// some (CSS) — nunca "não temos".
// Modo produto (PDP, 2026-10-01): o veículo é o do produto da página (data-*, do Liquid). Busca a
// outra linha e a mesma pela seção do "Complete o seu veículo" (ds-cart-sugestoes) e monta com a
// regra do carrinho (montarSugestoes): a outra linha primeiro, nunca o próprio produto.
// SEM top-level await (2026-10-01): no iPhone a vitrine do produto ficou presa no esqueleto — este
// módulo esperava, em cadeia, 4 módulos que a gaveta do carrinho importa ao MESMO tempo (dois deles
// com await no topo), e o Safari tem histórico de travar nesse grafo. Agora cada modo importa só o
// que usa: o modo produto depende de dois módulos sem await no topo (núcleo do veículo e do
// carrinho) e o carrossel vem depois, sem segurar os cards. Trava de segurança: sem resposta em
// PRAZO_MS, a fileira some (nunca esqueleto eterno). Com ?ds_debug na URL, a etapa/erro aparece na
// tela (diagnóstico no celular, onde não há console).
const mod = (k) => window.ArpineDS.importar(k);
const DEBUG = new URLSearchParams(location.search).has("ds_debug");
const PRAZO_MS = 12000;
let core, garagem, carrossel; // modos coleção e veículo: carregados em iniciarOutros()

const versoes = new WeakMap(); // raiz → número da última busca (troca rápida de veículo)
const esqueletos = new WeakMap(); // raiz → HTML dos esqueletos, para recomeçar

async function preencherVeiculo(raiz) {
  const minha = (versoes.get(raiz) ?? 0) + 1;
  versoes.set(raiz, minha);
  const plano = core.vitrineDoVeiculo(garagem.ativo(), {
    titulo: raiz.dataset.titulo,
    link: raiz.dataset.linkTexto,
    base: window.ArpineDS.vehiclePage,
  });
  if (!plano) {
    raiz.dataset.estado = "vazia";
    return;
  }
  const lista = raiz.querySelector("[data-ds-vitrine-lista]");
  lista.innerHTML = esqueletos.get(raiz);
  raiz.dataset.estado = "carregando";
  raiz.querySelector("[data-ds-vitrine-titulo]").textContent = plano.titulo;
  // FM4: no modo coleção o Liquid já rotula "Anterior/Próximo: <título>"; no modo veículo o
  // título só existe depois de preenchido — reescreve os dois rótulos com ele (ex.: "Anterior:
  // Para o seu Sprinter"), senão as até 3 vitrines da Home soam iguais pro leitor de tela.
  raiz.querySelector('[data-ds-carrossel-seta="-1"]')?.setAttribute("aria-label", `Anterior: ${plano.titulo}`);
  raiz.querySelector('[data-ds-carrossel-seta="1"]')?.setAttribute("aria-label", `Próximo: ${plano.titulo}`);
  const link = raiz.querySelector("[data-ds-vitrine-link]");
  link.textContent = plano.linkTexto;
  link.href = plano.href;
  link.hidden = false;
  try {
    const r = await fetch(plano.url);
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const doc = new DOMParser().parseFromString(await r.text(), "text/html");
    if (versoes.get(raiz) !== minha) return; // trocou de veículo no meio do caminho
    const limite = Number(raiz.dataset.limite) || 12;
    const itens = [...doc.querySelectorAll("[data-ds-results-grid] > li")].slice(0, limite);
    if (itens.length === 0) {
      raiz.dataset.estado = "vazia";
      return;
    }
    for (const li of itens) li.classList.add("ds-carrossel__item");
    lista.replaceChildren(...itens);
    lista.scrollLeft = 0; // veículo trocado: começa do primeiro card, não de onde o anterior parou
    raiz.dataset.estado = "pronta";
    // Depois de mostrar: com a raiz escondida a lista mede zero e o carrossel acharia que tudo cabe.
    carrossel.ligar(raiz.querySelector("[data-ds-carrossel]"));
  } catch (e) {
    console.error("[ds-vitrine]", e);
    if (versoes.get(raiz) === minha) raiz.dataset.estado = "vazia";
  }
}

const SECAO_SUGESTOES = "ds-cart-sugestoes";

async function cardsDe(url) {
  const r = await fetch(url);
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  const doc = new DOMParser().parseFromString(await r.text(), "text/html");
  return [...doc.querySelectorAll("[data-ds-sug]")].map((no) => ({ produtoId: no.dataset.produtoId, no }));
}

function mostrarDebug(raiz, texto) {
  if (!DEBUG) return;
  let p = raiz.querySelector("[data-ds-vitrine-debug]");
  if (!p) {
    p = document.createElement("p");
    p.dataset.dsVitrineDebug = "";
    p.className = "ds-vitrine__aviso-editor";
    raiz.prepend(p);
  }
  p.textContent = `[ds_debug] ${texto}`;
}

async function preencherProduto(raiz) {
  const d = raiz.dataset;
  let etapa = "módulos";
  const trava = setTimeout(() => {
    if (raiz.dataset.estado !== "carregando") return;
    raiz.dataset.estado = "vazia";
    mostrarDebug(raiz, `tempo esgotado na etapa: ${etapa}`);
  }, PRAZO_MS);
  try {
    const [veiculoCore, carrinho] = await Promise.all([mod("core"), mod("carrinho")]);
    const plano = carrinho.vitrineDoProduto({
      sufixo: d.sufixo,
      marca: d.marca,
      modelo: d.modelo,
      anos: (d.anos || "").split(","),
    });
    if (!plano) {
      raiz.dataset.estado = "vazia";
      return;
    }
    etapa = "busca dos cards";
    const [outra, mesma] = await Promise.all([
      cardsDe(veiculoCore.resultsUrl(plano.outra, plano.v, "section", SECAO_SUGESTOES)),
      cardsDe(veiculoCore.resultsUrl(plano.mesma, plano.v, "section", SECAO_SUGESTOES)),
    ]);
    etapa = "montagem";
    const limite = Number(d.limite) || 8;
    // a outra linha pode encher a fileira toda (maxOutra: limite); o produto da página nunca entra
    const lista = carrinho.montarSugestoes({ outra, acessorios: mesma, noCarrinho: [d.produtoId], max: limite, maxOutra: limite });
    if (!lista.length) {
      raiz.dataset.estado = "vazia";
      return;
    }
    const itens = lista.map((c) => document.importNode(c.no, true));
    for (const li of itens) li.classList.add("ds-carrossel__item");
    raiz.querySelector("[data-ds-vitrine-lista]").replaceChildren(...itens);
    raiz.dataset.estado = "pronta";
    mostrarDebug(raiz, `ok: ${itens.length} cards`);
    // as setas vêm depois e não seguram os cards (no celular o gesto já basta)
    mod("carrossel")
      .then((c) => c.ligar(raiz.querySelector("[data-ds-carrossel]")))
      .catch((e) => console.error("[ds-vitrine] carrossel", e));
  } catch (e) {
    console.error("[ds-vitrine]", e);
    raiz.dataset.estado = "vazia";
    mostrarDebug(raiz, `erro na etapa ${etapa}: ${e?.message ?? e}`);
  } finally {
    clearTimeout(trava);
  }
}

// Modos coleção e veículo: os módulos de sempre, carregados uma vez (promessa compartilhada).
let outrosProntos = null;
function carregarOutros() {
  outrosProntos ??= Promise.all([mod("core"), mod("garagem"), mod("carrossel")]).then(([c, g, k]) => {
    core = c;
    garagem = g.garagem;
    carrossel = k;
    // Trocou (ou tirou) o veículo ATIVO sem sair da Home: refaz a vitrine do veículo. Tirar da
    // garagem um veículo que não é o ativo não muda nada — nada de piscar esqueleto à toa.
    document.addEventListener(core.EVENTO, (e) => {
      if (!e.detail?.ativoMudou) return;
      for (const raiz of document.querySelectorAll('[data-ds-vitrine][data-modo="veiculo"]')) preencherVeiculo(raiz);
    });
  });
  return outrosProntos;
}

async function iniciar(raiz) {
  if (raiz.dataset.modo === "produto") {
    preencherProduto(raiz);
    return;
  }
  try {
    await carregarOutros();
  } catch (e) {
    console.error("[ds-vitrine]", e);
    if (raiz.dataset.modo === "veiculo") raiz.dataset.estado = "vazia";
    return;
  }
  if (raiz.dataset.modo === "veiculo") {
    if (!esqueletos.has(raiz)) esqueletos.set(raiz, raiz.querySelector("[data-ds-vitrine-lista]").innerHTML);
    preencherVeiculo(raiz);
  } else {
    carrossel.ligar(raiz.querySelector("[data-ds-carrossel]"));
  }
}

for (const raiz of document.querySelectorAll("[data-ds-vitrine]")) iniciar(raiz);

// Editor do tema: a seção é redesenhada a cada mudança de setting (o módulo não roda de novo).
document.addEventListener("shopify:section:load", (e) => {
  const raiz = e.target.querySelector?.("[data-ds-vitrine]");
  if (raiz) iniciar(raiz);
});
